export default __webpack_public_path__ + "static/media/sticker-I.d3ae2ed4.png";